/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../Fixes';
import Builder from '../../Builder';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "rstonboard": {
        "nested": {
          "OnboardToRestaurantsRequest": {
            "fields": {
              "type": {
                "type": "squareup.rstonboard.OnboardToRestaurantsRequest.Type",
                "id": 1,
                "rule": "optional"
              },
              "merchantToken": {
                "type": "string",
                "id": 2,
                "rule": "optional"
              },
              "source": {
                "type": "squareup.rstonboard.OnboardToRestaurantsRequest.Source",
                "id": 3,
                "rule": "optional"
              }
            },
            "nested": {
              "Type": {
                "values": {
                  "DO_NOT_USE": 0,
                  "FREE": 1,
                  "PRO": 2,
                  "FREE_TIER": 3,
                  "PLUS_TIER": 4,
                  "PREMIUM_TIER": 5,
                  "SQUARE_ONE": 9
                }
              },
              "Source": {
                "values": {
                  "DO_NOT_USE_SOURCE": 0,
                  "ONBOARD_FRONTEND": 1,
                  "DASHBOARD": 2,
                  "UNIFIED_CART": 3,
                  "MOBILE": 4,
                  "ONBOARDING": 5
                }
              }
            }
          },
          "OnboardToRestaurantsResponse": {
            "fields": {
              "status": {
                "type": "squareup.rstonboard.OnboardToRestaurantsResponse.Status",
                "id": 1,
                "rule": "optional"
              },
              "error": {
                "type": "squareup.rstonboard.OnboardToRestaurantsResponse.Error",
                "id": 2,
                "rule": "optional"
              },
              "isNoObligationFreeTrial": {
                "type": "bool",
                "id": 3,
                "rule": "optional"
              }
            },
            "nested": {
              "Error": {
                "values": {
                  "DO_NOT_USE_ERROR": 0,
                  "OPT_IN_FAILED": 1,
                  "ALREADY_OPTED_IN_FREE": 2,
                  "SUBSCRIPTION_FAILED": 3,
                  "HAS_EXISTING_SUBSCRIPTION": 4,
                  "NOT_ALLOWED_TO_SUBSCRIBE_IN_THIS_COUNTRY": 5,
                  "NOT_ALLOWED_TO_USE_SQUARE_ONE": 6
                }
              },
              "Status": {
                "values": {
                  "DO_NOT_USE_STATUS": 0,
                  "SUCCESS": 1,
                  "FAILURE": 2
                }
              }
            }
          },
          "OptOutOfRestaurantsRequest": {
            "fields": {
              "merchantToken": {
                "type": "string",
                "id": 1,
                "rule": "optional"
              }
            }
          },
          "OptOutOfRestaurantsResponse": {
            "fields": {
              "status": {
                "type": "squareup.rstonboard.OptOutOfRestaurantsResponse.Status",
                "id": 1,
                "rule": "optional"
              },
              "error": {
                "type": "squareup.rstonboard.OptOutOfRestaurantsResponse.Error",
                "id": 2,
                "rule": "optional"
              }
            },
            "nested": {
              "Error": {
                "values": {
                  "DO_NOT_USE_ERROR": 0,
                  "HAS_ACTIVE_SUBSCRIPTION": 1,
                  "OPT_OUT_FAILED": 2
                }
              },
              "Status": {
                "values": {
                  "DO_NOT_USE_STATUS": 0,
                  "SUCCESS": 1,
                  "FAILURE": 2
                }
              }
            }
          },
          "RetrieveBpoMenuImportsRequest": {
            "fields": {
              "merchantToken": {
                "type": "string",
                "id": 1,
                "rule": "optional"
              },
              "isOmnichannel": {
                "type": "bool",
                "id": 2,
                "rule": "optional"
              },
              "providers": {
                "type": "squareup.rstonboard.BpoMenuImport.BpoMenuImportProvider",
                "id": 3,
                "rule": "repeated"
              }
            }
          },
          "BpoMenuImport": {
            "fields": {
              "status": {
                "type": "squareup.rstonboard.BpoMenuImport.BpoMenuImportStatus",
                "id": 1,
                "rule": "optional"
              },
              "menuImportToken": {
                "type": "string",
                "id": 2,
                "rule": "optional"
              },
              "menuToken": {
                "type": "string",
                "id": 3,
                "rule": "optional"
              },
              "unitToken": {
                "type": "string",
                "id": 4,
                "rule": "optional"
              },
              "importProvider": {
                "type": "squareup.rstonboard.BpoMenuImport.BpoMenuImportProvider",
                "id": 5,
                "rule": "optional"
              },
              "menuName": {
                "type": "string",
                "id": 6,
                "rule": "optional"
              },
              "rootMenuGroupToken": {
                "type": "string",
                "id": 7,
                "rule": "optional"
              },
              "needsReview": {
                "type": "bool",
                "id": 8,
                "rule": "optional"
              }
            },
            "nested": {
              "BpoMenuImportStatus": {
                "values": {
                  "DO_NOT_USE_STATUS": 0,
                  "NOT_STARTED": 1,
                  "IN_PROGRESS": 2,
                  "SUCCEEDED": 3,
                  "FAILED": 4,
                  "EXPIRED": 5,
                  "SUSPENDED": 6
                }
              },
              "BpoMenuImportProvider": {
                "values": {
                  "DO_NOT_USE_PROVIDER": 0,
                  "WOFLOW": 1,
                  "WOFLOW_LINK": 2,
                  "WOFLOW_LINK_MIGRATION": 3,
                  "WOFLOW_LINK_UPLOAD": 4,
                  "GEN_AI": 5
                }
              }
            }
          },
          "RetrieveBpoMenuImportsResponse": {
            "fields": {
              "bpoMenuImports": {
                "type": "squareup.rstonboard.BpoMenuImport",
                "id": 1,
                "rule": "repeated"
              }
            }
          },
          "WoflowJobState": {
            "values": {
              "DO_NOT_USE_STATUS": 0,
              "initiated": 1,
              "in_progress": 2,
              "client_action_required": 3,
              "flagged": 4,
              "cancelled": 5,
              "failed": 6,
              "archived": 7,
              "completed": 8,
              "pending_approval": 9,
              "export_in_progress": 10,
              "export_failed": 11
            }
          },
          "WoflowClientMapping": {
            "fields": {
              "menuImportToken": {
                "type": "string",
                "id": 1,
                "rule": "optional"
              },
              "merchantToken": {
                "type": "string",
                "id": 2,
                "rule": "optional"
              },
              "catalogImportToken": {
                "type": "string",
                "id": 3,
                "rule": "optional"
              }
            }
          },
          "WoflowCallbackRequest": {
            "fields": {
              "id": {
                "type": "string",
                "id": 1,
                "rule": "optional"
              },
              "state": {
                "type": "squareup.rstonboard.WoflowJobState",
                "id": 2,
                "rule": "optional"
              },
              "deliveryUrl": {
                "type": "string",
                "id": 3,
                "rule": "optional"
              },
              "clientMappings": {
                "type": "squareup.rstonboard.WoflowClientMapping",
                "id": 4,
                "rule": "optional"
              },
              "statusReasons": {
                "type": "string",
                "id": 5,
                "rule": "repeated"
              },
              "notes": {
                "type": "string",
                "id": 6,
                "rule": "optional"
              }
            }
          },
          "WoflowCallbackResponse": {
            "fields": {
              "message": {
                "type": "string",
                "id": 1,
                "rule": "optional"
              }
            }
          },
          "MenuType": {
            "values": {
              "MENU_TYPE_DO_NOT_USE": 0,
              "all_day": 1,
              "breakfast": 2,
              "brunch": 3,
              "lunch": 4,
              "dinner": 5,
              "late_night": 6,
              "bar_menu": 7
            }
          },
          "MenuSize": {
            "values": {
              "MENU_SIZE_DO_NOT_USE": 0,
              "small": 1,
              "medium": 2,
              "large": 3
            }
          },
          "Cuisine": {
            "values": {
              "CUISINE_DO_NOT_USE": 0,
              "algerian": 1,
              "american": 2,
              "bagel_shop": 3,
              "bakery": 4,
              "bakery_cafe": 5,
              "bangladeshi": 6,
              "bar": 7,
              "BBQ": 8,
              "beer_garden": 9,
              "belgian": 10,
              "bistro": 11,
              "brasserie": 12,
              "brazilian": 13,
              "brewery": 14,
              "cafe_and_bakery": 15,
              "cafe_and_wine_bar": 16,
              "cajun": 17,
              "caribbean": 18,
              "chinese": 19,
              "chinese_american": 20,
              "coffee_shop": 21,
              "colombian": 22,
              "comfort_food": 23,
              "creole": 24,
              "creperie": 25,
              "cuban": 26,
              "cupcake_shop": 27,
              "czech": 28,
              "danish": 29,
              "deli": 30,
              "dim_sum": 31,
              "diner": 32,
              "donut_shop": 33,
              "dutch": 34,
              "egyptian": 35,
              "british": 36,
              "ethiopian": 37,
              "filipino": 38,
              "french": 39,
              "fried_chicken": 40,
              "german": 41,
              "ghanaian": 42,
              "greek": 43,
              "halal": 44,
              "hawaiian": 45,
              "hot_pot": 46,
              "ice_cream": 47,
              "indian": 48,
              "iranian": 49,
              "irish": 50,
              "israeli": 51,
              "italian": 52,
              "japanese": 53,
              "jewish": 54,
              "juice_bar": 55,
              "korean": 56,
              "korean_bbq": 57,
              "lebanese": 58,
              "mediterranean": 59,
              "mexican": 60,
              "molecular_gastronomy": 61,
              "moroccan": 62,
              "nepalese": 63,
              "new_england": 64,
              "nigerian": 65,
              "norwegian": 66,
              "pakistani": 67,
              "palestinian": 68,
              "pizza": 69,
              "polish": 70,
              "pub": 71,
              "puerto_rican": 72,
              "ramen_shop": 73,
              "russian": 74,
              "sandwich_shop": 75,
              "scottish": 76,
              "seafood_restaurant": 77,
              "smoothie_bar": 78,
              "soul_food": 79,
              "south_african": 80,
              "southern": 81,
              "spanish": 82,
              "sports_bar": 83,
              "sri_lankan": 84,
              "steakhouse": 85,
              "swedish": 86,
              "tacos_and_burritos_restaurant": 87,
              "tapas_bar": 88,
              "tex_mex": 89,
              "thai": 90,
              "turkish": 91,
              "ukrainian": 92,
              "vegetarian": 93,
              "vegan": 94,
              "vietnamese": 95,
              "wine_bar": 96,
              "yakitori": 97
            }
          },
          "GenerateAIMenuRequest": {
            "fields": {
              "unitTokens": {
                "type": "string",
                "id": 1,
                "rule": "repeated"
              },
              "menuType": {
                "type": "squareup.rstonboard.MenuType",
                "id": 2,
                "rule": "optional"
              },
              "menuSize": {
                "type": "squareup.rstonboard.MenuSize",
                "id": 3,
                "rule": "optional"
              },
              "cuisine": {
                "type": "squareup.rstonboard.Cuisine",
                "id": 4,
                "rule": "repeated"
              },
              "zipCode": {
                "type": "string",
                "id": 5,
                "rule": "optional"
              },
              "merchantToken": {
                "type": "string",
                "id": 6,
                "rule": "optional"
              },
              "menuName": {
                "type": "string",
                "id": 7,
                "rule": "optional"
              },
              "isOmnichannel": {
                "type": "bool",
                "id": 8,
                "rule": "optional"
              },
              "channelIds": {
                "type": "string",
                "id": 9,
                "rule": "repeated"
              },
              "visibleOnline": {
                "type": "bool",
                "id": 10,
                "rule": "optional"
              }
            }
          },
          "PrepareThirdPartyMenuMigrationRequest": {
            "fields": {
              "unitToken": {
                "type": "string",
                "id": 1,
                "rule": "optional"
              },
              "unitNickname": {
                "type": "string",
                "id": 2,
                "rule": "optional"
              },
              "merchantToken": {
                "type": "string",
                "id": 3,
                "rule": "optional"
              }
            }
          },
          "PrepareThirdPartyMenuMigrationResponse": {
            "fields": {
              "thirdPartyToken": {
                "type": "string",
                "id": 1,
                "rule": "optional"
              },
              "menuImportToken": {
                "type": "string",
                "id": 2,
                "rule": "optional"
              }
            }
          },
          "GenerateAIMenuResponse": {
            "fields": {
              "menuToken": {
                "type": "string",
                "id": 1,
                "rule": "optional"
              },
              "rootMenuGroupToken": {
                "type": "string",
                "id": 2,
                "rule": "optional"
              }
            }
          },
          "DuplicateMenuRequest": {
            "fields": {
              "newMenuName": {
                "type": "string",
                "id": 1,
                "rule": "optional"
              },
              "newMenuUnitToken": {
                "type": "string",
                "id": 2,
                "rule": "optional"
              },
              "sourceMenuToken": {
                "type": "string",
                "id": 3,
                "rule": "optional"
              },
              "merchantToken": {
                "type": "string",
                "id": 4,
                "rule": "optional"
              }
            }
          },
          "DuplicateMenuResponse": {
            "fields": {
              "menuToken": {
                "type": "string",
                "id": 1,
                "rule": "optional"
              }
            }
          },
          "OmnichannelMenusEnabledRequest": {
            "fields": {
              "merchantToken": {
                "type": "string",
                "id": 1,
                "rule": "optional"
              }
            }
          },
          "OmnichannelMenusEnabledResponse": {
            "fields": {
              "isOmnichannelMenusEnabled": {
                "type": "bool",
                "id": 1,
                "rule": "optional"
              },
              "isOmnichannelMenusMigrated": {
                "type": "bool",
                "id": 2,
                "rule": "optional"
              },
              "isOmnichannelMenusFirstLook": {
                "type": "bool",
                "id": 3,
                "rule": "optional"
              },
              "migrationClonedGroupWithMultipleParents": {
                "type": "bool",
                "id": 4,
                "rule": "optional"
              }
            }
          },
          "CompleteOmnichannelMenuMigrationRequest": {
            "fields": {
              "merchantToken": {
                "type": "string",
                "id": 1,
                "rule": "optional"
              },
              "success": {
                "type": "bool",
                "id": 2,
                "rule": "optional"
              },
              "groupDepthTruncated": {
                "type": "bool",
                "id": 3,
                "rule": "optional"
              },
              "groupCycleSevered": {
                "type": "bool",
                "id": 4,
                "rule": "optional"
              },
              "groupNonItemTilesRemoved": {
                "type": "bool",
                "id": 5,
                "rule": "optional"
              },
              "clonedGroupWithMultipleParents": {
                "type": "bool",
                "id": 6,
                "rule": "optional"
              },
              "hadOmnichannelMenus": {
                "type": "bool",
                "id": 7,
                "rule": "optional"
              }
            }
          },
          "CompleteOmnichannelMenuMigrationResponse": {
            "fields": {}
          },
          "ReverseOmnichannelMenuMigrationRequest": {
            "fields": {
              "merchantToken": {
                "type": "string",
                "id": 1,
                "rule": "optional"
              }
            }
          },
          "ReverseOmnichannelMenuMigrationResponse": {
            "fields": {}
          },
          "SetOmnichannelMenusFirstLookRequest": {
            "fields": {
              "migratedMenusFirstLookCompleted": {
                "type": "bool",
                "id": 1,
                "rule": "optional"
              }
            }
          },
          "SetOmnichannelMenusFirstLookResponse": {
            "fields": {}
          },
          "MenuMigrationStartedRequest": {
            "fields": {
              "merchantToken": {
                "type": "string",
                "id": 1,
                "rule": "optional"
              },
              "menuImportToken": {
                "type": "string",
                "id": 2,
                "rule": "optional"
              },
              "type": {
                "type": "squareup.rstonboard.MenuMigrationStartedRequest.Type",
                "id": 4,
                "rule": "optional"
              }
            },
            "nested": {
              "Type": {
                "values": {
                  "DO_NOT_USE_TYPE": 0,
                  "MIGRATION": 1,
                  "UPLOAD": 2
                }
              }
            }
          },
          "MenuMigrationStartedResponse": {
            "fields": {
              "status": {
                "type": "squareup.rstonboard.MenuMigrationStartedResponse.Status",
                "id": 1,
                "rule": "optional"
              },
              "error": {
                "type": "squareup.rstonboard.MenuMigrationStartedResponse.Error",
                "id": 2,
                "rule": "optional"
              }
            },
            "nested": {
              "Error": {
                "values": {
                  "DO_NOT_USE_ERROR": 0,
                  "NOT_ACCEPTING_MENU_MIGRATIONS": 1
                }
              },
              "Status": {
                "values": {
                  "DO_NOT_USE_STATUS": 0,
                  "SUCCESS": 1,
                  "FAILURE": 2
                }
              }
            }
          },
          "UpdateMenuMigrationRequest": {
            "fields": {
              "merchantToken": {
                "type": "string",
                "id": 1,
                "rule": "optional"
              },
              "menuImportToken": {
                "type": "string",
                "id": 2,
                "rule": "optional"
              },
              "menuName": {
                "type": "string",
                "id": 3,
                "rule": "optional"
              },
              "isOmnichannel": {
                "type": "bool",
                "id": 4,
                "rule": "optional"
              },
              "unitTokens": {
                "type": "string",
                "id": 5,
                "rule": "repeated"
              },
              "channelIds": {
                "type": "string",
                "id": 6,
                "rule": "repeated"
              },
              "availabilityPeriodIds": {
                "type": "string",
                "id": 7,
                "rule": "repeated"
              },
              "onlineChannelsVisible": {
                "type": "bool",
                "id": 8,
                "rule": "optional"
              }
            }
          },
          "UpdateMenuMigrationResponse": {
            "fields": {
              "status": {
                "type": "squareup.rstonboard.UpdateMenuMigrationResponse.Status",
                "id": 1,
                "rule": "optional"
              },
              "error": {
                "type": "squareup.rstonboard.UpdateMenuMigrationResponse.Error",
                "id": 2,
                "rule": "optional"
              }
            },
            "nested": {
              "Error": {
                "values": {
                  "DO_NOT_USE_ERROR": 0,
                  "NOT_ACCEPTING_MENU_MIGRATIONS": 1
                }
              },
              "Status": {
                "values": {
                  "DO_NOT_USE_STATUS": 0,
                  "SUCCESS": 1,
                  "FAILURE": 2
                }
              }
            }
          },
          "ReviewMenuImportRequest": {
            "fields": {
              "menuImportToken": {
                "type": "string",
                "id": 1,
                "rule": "optional"
              }
            }
          },
          "ReviewMenuImportResponse": {
            "fields": {
              "status": {
                "type": "squareup.rstonboard.ReviewMenuImportResponse.Status",
                "id": 1,
                "rule": "optional"
              },
              "error": {
                "type": "squareup.rstonboard.ReviewMenuImportResponse.Error",
                "id": 2,
                "rule": "optional"
              }
            },
            "nested": {
              "Error": {
                "values": {
                  "DO_NOT_USE_ERROR": 0,
                  "REVIEW_FAILED": 1
                }
              },
              "Status": {
                "values": {
                  "DO_NOT_USE_STATUS": 0,
                  "SUCCESS": 1,
                  "FAILURE": 2
                }
              }
            }
          },
          "CheckSposToRstMigrationEligibilityRequest": {
            "fields": {
              "merchantToken": {
                "type": "string",
                "id": 1,
                "rule": "optional"
              },
              "locationIds": {
                "type": "string",
                "id": 2,
                "rule": "repeated"
              },
              "enableOmnichannelMenus": {
                "type": "bool",
                "id": 3,
                "rule": "optional"
              }
            }
          },
          "CheckSposToRstMigrationEligibilityResponse": {
            "fields": {
              "merchantToken": {
                "type": "string",
                "id": 1,
                "rule": "optional"
              },
              "overallEligibility": {
                "type": "squareup.rstonboard.CheckSposToRstMigrationEligibilityResponse.OverallMigrationEligibilityStatus",
                "id": 2,
                "rule": "required"
              },
              "locations": {
                "type": "squareup.rstonboard.CheckSposToRstMigrationEligibilityResponse.LocationMigrationEligibility",
                "id": 3,
                "rule": "repeated"
              },
              "error": {
                "type": "squareup.rstonboard.CheckSposToRstMigrationEligibilityResponse.Error",
                "id": 4,
                "rule": "optional"
              }
            },
            "nested": {
              "MigrationType": {
                "values": {
                  "DO_NOT_USE_MIGRATION_TYPE": 0,
                  "SKIP_MIGRATION": 1,
                  "DEFAULT": 2,
                  "CUSTOM": 3,
                  "SKIP_MIGRATION_FLOW": 4
                }
              },
              "OverallMigrationEligibilityStatus": {
                "values": {
                  "DO_NOT_USE_OVERALL_MIGRATION_ELIGIBILITY_STATUS": 0,
                  "ELIGIBLE": 1,
                  "INELIGIBLE": 2,
                  "PARTIAL": 3,
                  "ERROR": 4,
                  "SKIP_ROUTE": 5
                }
              },
              "ErrorType": {
                "values": {
                  "DO_NOT_USE_ERROR": 0,
                  "INVALID_REQUEST_ERROR": 1,
                  "INTERNAL_SERVER_ERROR": 2,
                  "CATALOG_API_FAILED": 3,
                  "INVALID_PERMISSIONS": 4,
                  "OMNICHANNEL_MENUS_IS_DISABLED": 5
                }
              },
              "Error": {
                "fields": {
                  "type": {
                    "type": "squareup.rstonboard.CheckSposToRstMigrationEligibilityResponse.ErrorType",
                    "id": 1,
                    "rule": "optional"
                  },
                  "message": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  }
                }
              },
              "LocationMigrationEligibility": {
                "fields": {
                  "locationId": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "migrationType": {
                    "type": "squareup.rstonboard.CheckSposToRstMigrationEligibilityResponse.MigrationType",
                    "id": 2,
                    "rule": "optional"
                  },
                  "sposPageNames": {
                    "type": "string",
                    "id": 3,
                    "rule": "repeated"
                  }
                }
              }
            }
          },
          "OnboardService": {
            "methods": {
              "OnboardToRestaurants": {
                "requestType": "squareup.rstonboard.OnboardToRestaurantsRequest",
                "responseType": "squareup.rstonboard.OnboardToRestaurantsResponse"
              },
              "OptOutOfRestaurants": {
                "requestType": "squareup.rstonboard.OptOutOfRestaurantsRequest",
                "responseType": "squareup.rstonboard.OptOutOfRestaurantsResponse"
              },
              "CheckSposToRstMigrationEligibility": {
                "requestType": "squareup.rstonboard.CheckSposToRstMigrationEligibilityRequest",
                "responseType": "squareup.rstonboard.CheckSposToRstMigrationEligibilityResponse"
              }
            }
          },
          "MenuImportService": {
            "methods": {
              "RetrieveBpoMenuImports": {
                "requestType": "squareup.rstonboard.RetrieveBpoMenuImportsRequest",
                "responseType": "squareup.rstonboard.RetrieveBpoMenuImportsResponse"
              },
              "WoflowCallback": {
                "requestType": "squareup.rstonboard.WoflowCallbackRequest",
                "responseType": "squareup.rstonboard.WoflowCallbackResponse"
              },
              "GenerateAIMenu": {
                "requestType": "squareup.rstonboard.GenerateAIMenuRequest",
                "responseType": "squareup.rstonboard.GenerateAIMenuResponse"
              },
              "ReviewMenuImport": {
                "requestType": "squareup.rstonboard.ReviewMenuImportRequest",
                "responseType": "squareup.rstonboard.ReviewMenuImportResponse"
              }
            }
          },
          "MenuService": {
            "methods": {
              "DuplicateMenu": {
                "requestType": "squareup.rstonboard.DuplicateMenuRequest",
                "responseType": "squareup.rstonboard.DuplicateMenuResponse"
              },
              "OmnichannelMenusEnabled": {
                "requestType": "squareup.rstonboard.OmnichannelMenusEnabledRequest",
                "responseType": "squareup.rstonboard.OmnichannelMenusEnabledResponse"
              },
              "CompleteOmnichannelMenuMigration": {
                "requestType": "squareup.rstonboard.CompleteOmnichannelMenuMigrationRequest",
                "responseType": "squareup.rstonboard.CompleteOmnichannelMenuMigrationResponse"
              },
              "ReverseOmnichannelMenuMigration": {
                "requestType": "squareup.rstonboard.ReverseOmnichannelMenuMigrationRequest",
                "responseType": "squareup.rstonboard.ReverseOmnichannelMenuMigrationResponse"
              },
              "SetOmnichannelMenusFirstLook": {
                "requestType": "squareup.rstonboard.SetOmnichannelMenusFirstLookRequest",
                "responseType": "squareup.rstonboard.SetOmnichannelMenusFirstLookResponse"
              }
            }
          },
          "ThirdPartyMenuMigrationService": {
            "methods": {
              "PrepareThirdPartyMenuMigration": {
                "requestType": "squareup.rstonboard.PrepareThirdPartyMenuMigrationRequest",
                "responseType": "squareup.rstonboard.PrepareThirdPartyMenuMigrationResponse"
              },
              "MenuMigrationStarted": {
                "requestType": "squareup.rstonboard.MenuMigrationStartedRequest",
                "responseType": "squareup.rstonboard.MenuMigrationStartedResponse"
              },
              "UpdateMenuMigration": {
                "requestType": "squareup.rstonboard.UpdateMenuMigrationRequest",
                "responseType": "squareup.rstonboard.UpdateMenuMigrationResponse"
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.rstonboard?.nested?.OnboardToRestaurantsRequest && !$root.nested?.squareup?.nested?.rstonboard?.nested?.OnboardToRestaurantsRequest?.nested?.Type && !$root.nested?.squareup?.nested?.rstonboard?.nested?.OnboardToRestaurantsRequest?.nested?.Source && !$root.nested?.squareup?.nested?.rstonboard?.nested?.OnboardToRestaurantsResponse && !$root.nested?.squareup?.nested?.rstonboard?.nested?.OnboardToRestaurantsResponse?.nested?.Error && !$root.nested?.squareup?.nested?.rstonboard?.nested?.OnboardToRestaurantsResponse?.nested?.Status && !$root.nested?.squareup?.nested?.rstonboard?.nested?.OptOutOfRestaurantsRequest && !$root.nested?.squareup?.nested?.rstonboard?.nested?.OptOutOfRestaurantsResponse && !$root.nested?.squareup?.nested?.rstonboard?.nested?.OptOutOfRestaurantsResponse?.nested?.Error && !$root.nested?.squareup?.nested?.rstonboard?.nested?.OptOutOfRestaurantsResponse?.nested?.Status && !$root.nested?.squareup?.nested?.rstonboard?.nested?.RetrieveBpoMenuImportsRequest && !$root.nested?.squareup?.nested?.rstonboard?.nested?.BpoMenuImport && !$root.nested?.squareup?.nested?.rstonboard?.nested?.BpoMenuImport?.nested?.BpoMenuImportStatus && !$root.nested?.squareup?.nested?.rstonboard?.nested?.BpoMenuImport?.nested?.BpoMenuImportProvider && !$root.nested?.squareup?.nested?.rstonboard?.nested?.RetrieveBpoMenuImportsResponse && !$root.nested?.squareup?.nested?.rstonboard?.nested?.WoflowJobState && !$root.nested?.squareup?.nested?.rstonboard?.nested?.WoflowClientMapping && !$root.nested?.squareup?.nested?.rstonboard?.nested?.WoflowCallbackRequest && !$root.nested?.squareup?.nested?.rstonboard?.nested?.WoflowCallbackResponse && !$root.nested?.squareup?.nested?.rstonboard?.nested?.MenuType && !$root.nested?.squareup?.nested?.rstonboard?.nested?.MenuSize && !$root.nested?.squareup?.nested?.rstonboard?.nested?.Cuisine && !$root.nested?.squareup?.nested?.rstonboard?.nested?.GenerateAIMenuRequest && !$root.nested?.squareup?.nested?.rstonboard?.nested?.PrepareThirdPartyMenuMigrationRequest && !$root.nested?.squareup?.nested?.rstonboard?.nested?.PrepareThirdPartyMenuMigrationResponse && !$root.nested?.squareup?.nested?.rstonboard?.nested?.GenerateAIMenuResponse && !$root.nested?.squareup?.nested?.rstonboard?.nested?.DuplicateMenuRequest && !$root.nested?.squareup?.nested?.rstonboard?.nested?.DuplicateMenuResponse && !$root.nested?.squareup?.nested?.rstonboard?.nested?.OmnichannelMenusEnabledRequest && !$root.nested?.squareup?.nested?.rstonboard?.nested?.OmnichannelMenusEnabledResponse && !$root.nested?.squareup?.nested?.rstonboard?.nested?.CompleteOmnichannelMenuMigrationRequest && !$root.nested?.squareup?.nested?.rstonboard?.nested?.CompleteOmnichannelMenuMigrationResponse && !$root.nested?.squareup?.nested?.rstonboard?.nested?.ReverseOmnichannelMenuMigrationRequest && !$root.nested?.squareup?.nested?.rstonboard?.nested?.ReverseOmnichannelMenuMigrationResponse && !$root.nested?.squareup?.nested?.rstonboard?.nested?.SetOmnichannelMenusFirstLookRequest && !$root.nested?.squareup?.nested?.rstonboard?.nested?.SetOmnichannelMenusFirstLookResponse && !$root.nested?.squareup?.nested?.rstonboard?.nested?.MenuMigrationStartedRequest && !$root.nested?.squareup?.nested?.rstonboard?.nested?.MenuMigrationStartedRequest?.nested?.Type && !$root.nested?.squareup?.nested?.rstonboard?.nested?.MenuMigrationStartedResponse && !$root.nested?.squareup?.nested?.rstonboard?.nested?.MenuMigrationStartedResponse?.nested?.Error && !$root.nested?.squareup?.nested?.rstonboard?.nested?.MenuMigrationStartedResponse?.nested?.Status && !$root.nested?.squareup?.nested?.rstonboard?.nested?.UpdateMenuMigrationRequest && !$root.nested?.squareup?.nested?.rstonboard?.nested?.UpdateMenuMigrationResponse && !$root.nested?.squareup?.nested?.rstonboard?.nested?.UpdateMenuMigrationResponse?.nested?.Error && !$root.nested?.squareup?.nested?.rstonboard?.nested?.UpdateMenuMigrationResponse?.nested?.Status && !$root.nested?.squareup?.nested?.rstonboard?.nested?.ReviewMenuImportRequest && !$root.nested?.squareup?.nested?.rstonboard?.nested?.ReviewMenuImportResponse && !$root.nested?.squareup?.nested?.rstonboard?.nested?.ReviewMenuImportResponse?.nested?.Error && !$root.nested?.squareup?.nested?.rstonboard?.nested?.ReviewMenuImportResponse?.nested?.Status && !$root.nested?.squareup?.nested?.rstonboard?.nested?.CheckSposToRstMigrationEligibilityRequest && !$root.nested?.squareup?.nested?.rstonboard?.nested?.CheckSposToRstMigrationEligibilityResponse && !$root.nested?.squareup?.nested?.rstonboard?.nested?.CheckSposToRstMigrationEligibilityResponse?.nested?.MigrationType && !$root.nested?.squareup?.nested?.rstonboard?.nested?.CheckSposToRstMigrationEligibilityResponse?.nested?.OverallMigrationEligibilityStatus && !$root.nested?.squareup?.nested?.rstonboard?.nested?.CheckSposToRstMigrationEligibilityResponse?.nested?.ErrorType && !$root.nested?.squareup?.nested?.rstonboard?.nested?.CheckSposToRstMigrationEligibilityResponse?.nested?.Error && !$root.nested?.squareup?.nested?.rstonboard?.nested?.CheckSposToRstMigrationEligibilityResponse?.nested?.LocationMigrationEligibility && !$root.nested?.squareup?.nested?.rstonboard?.nested?.OnboardService && !$root.nested?.squareup?.nested?.rstonboard?.nested?.MenuImportService && !$root.nested?.squareup?.nested?.rstonboard?.nested?.MenuService && !$root.nested?.squareup?.nested?.rstonboard?.nested?.ThirdPartyMenuMigrationService) {
  $root.addJSON(jsonData);
}

/**
 * SOURCE OnboardToRestaurantsRequest @ squareup/rstonboard/service.proto at 14:1
 */
export const OnboardToRestaurantsRequest = $root.lookupType('squareup.rstonboard.OnboardToRestaurantsRequest');
fixType(OnboardToRestaurantsRequest, {
  type: {
    required: true
  }
});
Builder.createAndAttachToType(OnboardToRestaurantsRequest);
/**
 * SOURCE Type @ squareup/rstonboard/service.proto at 15:3
 */
OnboardToRestaurantsRequest.Type = $root.lookupEnum('squareup.rstonboard.OnboardToRestaurantsRequest.Type').values;
/**
 * Onboarding source to segment sellers who are eligible for the Omnichannel Menus experience
 *
 * SOURCE Source @ squareup/rstonboard/service.proto at 44:3
 */
OnboardToRestaurantsRequest.Source = $root.lookupEnum('squareup.rstonboard.OnboardToRestaurantsRequest.Source').values;
/**
 * SOURCE OnboardToRestaurantsResponse @ squareup/rstonboard/service.proto at 56:1
 */
export const OnboardToRestaurantsResponse = $root.lookupType('squareup.rstonboard.OnboardToRestaurantsResponse');
fixType(OnboardToRestaurantsResponse, {
  status: {
    required: true
  }
});
Builder.createAndAttachToType(OnboardToRestaurantsResponse);
/**
 * Used to indicated why the request to onboard to Restaurants failed. In the endpoint,
 * we first set the MDS restaurants_joined_at flag for the merchant. If that request succeeds
 * and the merchant has requested to onboard to Restaurants Pro, then we also create the sub2
 * subscription.
 *
 * OPT_IN_FAILED means the merchant was not opted into any tier of the Restaurants
 * experience. Eng-wise, this means setting the MDS restaurants_joined_at flag has failed.
 *
 * ALREADY_OPTED_IN_FREE only applies for merchants who are already Restaurants Free merchants
 * attempting to onboard to Restaurants Free again. Eng-wise, this means the MDS
 * restaurants_joined_at flag was already set for the merchant before the request.
 *
 * SUBSCRIPTION_FAILED and HAS_EXISTING_SUBSCRIPTION only applies for merchants who are
 * subscribing to Restaurants Pro. Eng-wise, the endpoint has successfully set the MDS
 * restaurants_joined_at flag, then attempted to create the sub2 subscription, but received a
 * failure response.
 *
 * NOT_ALLOWED_TO_SUBSCRIBE_IN_THIS_COUNTRY means the merchant is not in a country supported
 * by Restaurants.
 *
 * NOT_ALLOWED_TO_USE_SQUARE_ONE means the request contained the SQUARE_ONE type, but the merchant
 * is not allowed to use Square One.
 *
 * SOURCE Error @ squareup/rstonboard/service.proto at 81:3
 */
OnboardToRestaurantsResponse.Error = $root.lookupEnum('squareup.rstonboard.OnboardToRestaurantsResponse.Error').values;
/**
 * SOURCE Status @ squareup/rstonboard/service.proto at 91:3
 */
OnboardToRestaurantsResponse.Status = $root.lookupEnum('squareup.rstonboard.OnboardToRestaurantsResponse.Status').values;
/**
 * This action is called by Regulator to opt a merchant out of the Restaurants Free
 * experience. This will essentially unset the MDS restaurants_joined_at flag, and
 * remove access to any Restaurants features for that merchant.
 *
 * SOURCE OptOutOfRestaurantsRequest @ squareup/rstonboard/service.proto at 328:1
 */
export const OptOutOfRestaurantsRequest = $root.lookupType('squareup.rstonboard.OptOutOfRestaurantsRequest');
fixType(OptOutOfRestaurantsRequest, {
  merchantToken: {
    required: true
  }
});
Builder.createAndAttachToType(OptOutOfRestaurantsRequest);
/**
 * SOURCE OptOutOfRestaurantsResponse @ squareup/rstonboard/service.proto at 332:1
 */
export const OptOutOfRestaurantsResponse = $root.lookupType('squareup.rstonboard.OptOutOfRestaurantsResponse');
fixType(OptOutOfRestaurantsResponse, {
  status: {
    required: true
  }
});
Builder.createAndAttachToType(OptOutOfRestaurantsResponse);
/**
 * SOURCE Error @ squareup/rstonboard/service.proto at 333:3
 */
OptOutOfRestaurantsResponse.Error = $root.lookupEnum('squareup.rstonboard.OptOutOfRestaurantsResponse.Error').values;
/**
 * SOURCE Status @ squareup/rstonboard/service.proto at 339:3
 */
OptOutOfRestaurantsResponse.Status = $root.lookupEnum('squareup.rstonboard.OptOutOfRestaurantsResponse.Status').values;
/**
 * SOURCE RetrieveBpoMenuImportsRequest @ squareup/rstonboard/service.proto at 364:1
 */
export const RetrieveBpoMenuImportsRequest = $root.lookupType('squareup.rstonboard.RetrieveBpoMenuImportsRequest');
fixType(RetrieveBpoMenuImportsRequest);
Builder.createAndAttachToType(RetrieveBpoMenuImportsRequest);
/**
 * SOURCE BpoMenuImport @ squareup/rstonboard/service.proto at 371:1
 */
export const BpoMenuImport = $root.lookupType('squareup.rstonboard.BpoMenuImport');
fixType(BpoMenuImport);
Builder.createAndAttachToType(BpoMenuImport);
/**
 * SOURCE BpoMenuImportStatus @ squareup/rstonboard/service.proto at 372:3
 */
BpoMenuImport.BpoMenuImportStatus = $root.lookupEnum('squareup.rstonboard.BpoMenuImport.BpoMenuImportStatus').values;
/**
 * SOURCE BpoMenuImportProvider @ squareup/rstonboard/service.proto at 382:3
 */
BpoMenuImport.BpoMenuImportProvider = $root.lookupEnum('squareup.rstonboard.BpoMenuImport.BpoMenuImportProvider').values;
/**
 * SOURCE RetrieveBpoMenuImportsResponse @ squareup/rstonboard/service.proto at 406:1
 */
export const RetrieveBpoMenuImportsResponse = $root.lookupType('squareup.rstonboard.RetrieveBpoMenuImportsResponse');
fixType(RetrieveBpoMenuImportsResponse);
Builder.createAndAttachToType(RetrieveBpoMenuImportsResponse);
/**
 * Possible job states defined by Woflow.
 * For more detail reference: https://docs.woflow.com/api/webhooks/job-state-webhook
 *
 * SOURCE WoflowJobState @ squareup/rstonboard/service.proto at 414:1
 */
export const WoflowJobState = $root.lookupEnum('squareup.rstonboard.WoflowJobState').values;
/**
 * SOURCE WoflowClientMapping @ squareup/rstonboard/service.proto at 429:1
 */
export const WoflowClientMapping = $root.lookupType('squareup.rstonboard.WoflowClientMapping');
fixType(WoflowClientMapping);
Builder.createAndAttachToType(WoflowClientMapping);
/**
 * SOURCE WoflowCallbackRequest @ squareup/rstonboard/service.proto at 435:1
 */
export const WoflowCallbackRequest = $root.lookupType('squareup.rstonboard.WoflowCallbackRequest');
fixType(WoflowCallbackRequest);
Builder.createAndAttachToType(WoflowCallbackRequest);
/**
 * SOURCE WoflowCallbackResponse @ squareup/rstonboard/service.proto at 444:1
 */
export const WoflowCallbackResponse = $root.lookupType('squareup.rstonboard.WoflowCallbackResponse');
fixType(WoflowCallbackResponse);
Builder.createAndAttachToType(WoflowCallbackResponse);
/**
 * SOURCE MenuType @ squareup/rstonboard/service.proto at 448:1
 */
export const MenuType = $root.lookupEnum('squareup.rstonboard.MenuType').values;
/**
 * SOURCE MenuSize @ squareup/rstonboard/service.proto at 459:1
 */
export const MenuSize = $root.lookupEnum('squareup.rstonboard.MenuSize').values;
/**
 * SOURCE Cuisine @ squareup/rstonboard/service.proto at 466:1
 */
export const Cuisine = $root.lookupEnum('squareup.rstonboard.Cuisine').values;
/**
 * SOURCE GenerateAIMenuRequest @ squareup/rstonboard/service.proto at 567:1
 */
export const GenerateAIMenuRequest = $root.lookupType('squareup.rstonboard.GenerateAIMenuRequest');
fixType(GenerateAIMenuRequest, {
  unitTokens: {
    required: true
  },
  menuType: {
    required: true
  },
  menuSize: {
    required: true
  },
  cuisine: {
    required: true
  },
  zipCode: {
    required: true
  },
  menuName: {
    required: true
  }
});
Builder.createAndAttachToType(GenerateAIMenuRequest);
/**
 * This action handles the pre-requisites before starting menu migration using Woflow Link
 * 1. Retries, or creates a single menu_import with NOT_STARTED status for BPOProvider.WOFLOW_LINK
 * 2. Generate a JWT token for Woflow to authenticate the request
 *
 * SOURCE PrepareThirdPartyMenuMigrationRequest @ squareup/rstonboard/service.proto at 590:1
 */
export const PrepareThirdPartyMenuMigrationRequest = $root.lookupType('squareup.rstonboard.PrepareThirdPartyMenuMigrationRequest');
fixType(PrepareThirdPartyMenuMigrationRequest, {
  unitToken: {
    required: true
  },
  unitNickname: {
    required: true
  }
});
Builder.createAndAttachToType(PrepareThirdPartyMenuMigrationRequest);
/**
 * SOURCE PrepareThirdPartyMenuMigrationResponse @ squareup/rstonboard/service.proto at 601:1
 */
export const PrepareThirdPartyMenuMigrationResponse = $root.lookupType('squareup.rstonboard.PrepareThirdPartyMenuMigrationResponse');
fixType(PrepareThirdPartyMenuMigrationResponse);
Builder.createAndAttachToType(PrepareThirdPartyMenuMigrationResponse);
/**
 * SOURCE GenerateAIMenuResponse @ squareup/rstonboard/service.proto at 606:1
 */
export const GenerateAIMenuResponse = $root.lookupType('squareup.rstonboard.GenerateAIMenuResponse');
fixType(GenerateAIMenuResponse);
Builder.createAndAttachToType(GenerateAIMenuResponse);
/**
 * SOURCE DuplicateMenuRequest @ squareup/rstonboard/service.proto at 612:1
 */
export const DuplicateMenuRequest = $root.lookupType('squareup.rstonboard.DuplicateMenuRequest');
fixType(DuplicateMenuRequest);
Builder.createAndAttachToType(DuplicateMenuRequest);
/**
 * SOURCE DuplicateMenuResponse @ squareup/rstonboard/service.proto at 625:1
 */
export const DuplicateMenuResponse = $root.lookupType('squareup.rstonboard.DuplicateMenuResponse');
fixType(DuplicateMenuResponse);
Builder.createAndAttachToType(DuplicateMenuResponse);
/**
 * SOURCE OmnichannelMenusEnabledRequest @ squareup/rstonboard/service.proto at 630:1
 */
export const OmnichannelMenusEnabledRequest = $root.lookupType('squareup.rstonboard.OmnichannelMenusEnabledRequest');
fixType(OmnichannelMenusEnabledRequest);
Builder.createAndAttachToType(OmnichannelMenusEnabledRequest);
/**
 * SOURCE OmnichannelMenusEnabledResponse @ squareup/rstonboard/service.proto at 635:1
 */
export const OmnichannelMenusEnabledResponse = $root.lookupType('squareup.rstonboard.OmnichannelMenusEnabledResponse');
fixType(OmnichannelMenusEnabledResponse);
Builder.createAndAttachToType(OmnichannelMenusEnabledResponse);
/**
 * SOURCE CompleteOmnichannelMenuMigrationRequest @ squareup/rstonboard/service.proto at 646:1
 */
export const CompleteOmnichannelMenuMigrationRequest = $root.lookupType('squareup.rstonboard.CompleteOmnichannelMenuMigrationRequest');
fixType(CompleteOmnichannelMenuMigrationRequest);
Builder.createAndAttachToType(CompleteOmnichannelMenuMigrationRequest);
/**
 * SOURCE CompleteOmnichannelMenuMigrationResponse @ squareup/rstonboard/service.proto at 657:1
 */
export const CompleteOmnichannelMenuMigrationResponse = $root.lookupType('squareup.rstonboard.CompleteOmnichannelMenuMigrationResponse');
fixType(CompleteOmnichannelMenuMigrationResponse);
Builder.createAndAttachToType(CompleteOmnichannelMenuMigrationResponse);
/**
 * SOURCE ReverseOmnichannelMenuMigrationRequest @ squareup/rstonboard/service.proto at 659:1
 */
export const ReverseOmnichannelMenuMigrationRequest = $root.lookupType('squareup.rstonboard.ReverseOmnichannelMenuMigrationRequest');
fixType(ReverseOmnichannelMenuMigrationRequest);
Builder.createAndAttachToType(ReverseOmnichannelMenuMigrationRequest);
/**
 * SOURCE ReverseOmnichannelMenuMigrationResponse @ squareup/rstonboard/service.proto at 663:1
 */
export const ReverseOmnichannelMenuMigrationResponse = $root.lookupType('squareup.rstonboard.ReverseOmnichannelMenuMigrationResponse');
fixType(ReverseOmnichannelMenuMigrationResponse);
Builder.createAndAttachToType(ReverseOmnichannelMenuMigrationResponse);
/**
 * SOURCE SetOmnichannelMenusFirstLookRequest @ squareup/rstonboard/service.proto at 665:1
 */
export const SetOmnichannelMenusFirstLookRequest = $root.lookupType('squareup.rstonboard.SetOmnichannelMenusFirstLookRequest');
fixType(SetOmnichannelMenusFirstLookRequest);
Builder.createAndAttachToType(SetOmnichannelMenusFirstLookRequest);
/**
 * SOURCE SetOmnichannelMenusFirstLookResponse @ squareup/rstonboard/service.proto at 669:1
 */
export const SetOmnichannelMenusFirstLookResponse = $root.lookupType('squareup.rstonboard.SetOmnichannelMenusFirstLookResponse');
fixType(SetOmnichannelMenusFirstLookResponse);
Builder.createAndAttachToType(SetOmnichannelMenusFirstLookResponse);
/**
 * SOURCE MenuMigrationStartedRequest @ squareup/rstonboard/service.proto at 671:1
 */
export const MenuMigrationStartedRequest = $root.lookupType('squareup.rstonboard.MenuMigrationStartedRequest');
fixType(MenuMigrationStartedRequest, {
  menuImportToken: {
    required: true
  }
});
Builder.createAndAttachToType(MenuMigrationStartedRequest);
/**
 * SOURCE Type @ squareup/rstonboard/service.proto at 672:3
 */
MenuMigrationStartedRequest.Type = $root.lookupEnum('squareup.rstonboard.MenuMigrationStartedRequest.Type').values;
/**
 * SOURCE MenuMigrationStartedResponse @ squareup/rstonboard/service.proto at 687:1
 */
export const MenuMigrationStartedResponse = $root.lookupType('squareup.rstonboard.MenuMigrationStartedResponse');
fixType(MenuMigrationStartedResponse, {
  status: {
    required: true
  }
});
Builder.createAndAttachToType(MenuMigrationStartedResponse);
/**
 * Used to indicate why the request to start menu migration failed.
 * This is useful when requests fail due to changes that are not BadRequestExceptions or NotFoundExceptions
 *
 * NOT_ACCEPTING_MENU_MIGRATIONS means the restaurant/use_external_menu_migration_service flag
 * was turned off after the menu import was created.
 *
 * SOURCE Error @ squareup/rstonboard/service.proto at 696:3
 */
MenuMigrationStartedResponse.Error = $root.lookupEnum('squareup.rstonboard.MenuMigrationStartedResponse.Error').values;
/**
 * SOURCE Status @ squareup/rstonboard/service.proto at 701:3
 */
MenuMigrationStartedResponse.Status = $root.lookupEnum('squareup.rstonboard.MenuMigrationStartedResponse.Status').values;
/**
 * SOURCE UpdateMenuMigrationRequest @ squareup/rstonboard/service.proto at 711:1
 */
export const UpdateMenuMigrationRequest = $root.lookupType('squareup.rstonboard.UpdateMenuMigrationRequest');
fixType(UpdateMenuMigrationRequest, {
  menuImportToken: {
    required: true
  },
  menuName: {
    required: true
  },
  unitTokens: {
    required: true
  }
});
Builder.createAndAttachToType(UpdateMenuMigrationRequest);
/**
 * SOURCE UpdateMenuMigrationResponse @ squareup/rstonboard/service.proto at 731:1
 */
export const UpdateMenuMigrationResponse = $root.lookupType('squareup.rstonboard.UpdateMenuMigrationResponse');
fixType(UpdateMenuMigrationResponse, {
  status: {
    required: true
  }
});
Builder.createAndAttachToType(UpdateMenuMigrationResponse);
/**
 * Used to indicate why the request to start menu migration failed.
 * This is useful when requests fail due to changes that are not BadRequestExceptions or NotFoundExceptions
 *
 * NOT_ACCEPTING_MENU_MIGRATIONS means the restaurant/use_external_menu_migration_service flag
 * was turned off after the menu import was created.
 *
 * SOURCE Error @ squareup/rstonboard/service.proto at 740:3
 */
UpdateMenuMigrationResponse.Error = $root.lookupEnum('squareup.rstonboard.UpdateMenuMigrationResponse.Error').values;
/**
 * SOURCE Status @ squareup/rstonboard/service.proto at 744:3
 */
UpdateMenuMigrationResponse.Status = $root.lookupEnum('squareup.rstonboard.UpdateMenuMigrationResponse.Status').values;
/**
 * SOURCE ReviewMenuImportRequest @ squareup/rstonboard/service.proto at 754:1
 */
export const ReviewMenuImportRequest = $root.lookupType('squareup.rstonboard.ReviewMenuImportRequest');
fixType(ReviewMenuImportRequest);
Builder.createAndAttachToType(ReviewMenuImportRequest);
/**
 * SOURCE ReviewMenuImportResponse @ squareup/rstonboard/service.proto at 758:1
 */
export const ReviewMenuImportResponse = $root.lookupType('squareup.rstonboard.ReviewMenuImportResponse');
fixType(ReviewMenuImportResponse, {
  status: {
    required: true
  }
});
Builder.createAndAttachToType(ReviewMenuImportResponse);
/**
 * Used to indicate why the request to review a menu import failed.
 * This is useful when requests fail due to changes that are not BadRequestExceptions or NotFoundExceptions
 *
 * REVIEW_FAILED means there was a server error that prevented the indicated menu import from being persisted
 * and the seller will need to try again.
 *
 * SOURCE Error @ squareup/rstonboard/service.proto at 766:3
 */
ReviewMenuImportResponse.Error = $root.lookupEnum('squareup.rstonboard.ReviewMenuImportResponse.Error').values;
/**
 * SOURCE Status @ squareup/rstonboard/service.proto at 770:3
 */
ReviewMenuImportResponse.Status = $root.lookupEnum('squareup.rstonboard.ReviewMenuImportResponse.Status').values;
/**
 * SOURCE CheckSposToRstMigrationEligibilityRequest @ squareup/rstonboard/service.proto at 787:1
 */
export const CheckSposToRstMigrationEligibilityRequest = $root.lookupType('squareup.rstonboard.CheckSposToRstMigrationEligibilityRequest');
fixType(CheckSposToRstMigrationEligibilityRequest, {
  merchantToken: {
    required: true
  }
});
Builder.createAndAttachToType(CheckSposToRstMigrationEligibilityRequest);
/**
 * SOURCE CheckSposToRstMigrationEligibilityResponse @ squareup/rstonboard/service.proto at 799:1
 */
export const CheckSposToRstMigrationEligibilityResponse = $root.lookupType('squareup.rstonboard.CheckSposToRstMigrationEligibilityResponse');
fixType(CheckSposToRstMigrationEligibilityResponse);
Builder.createAndAttachToType(CheckSposToRstMigrationEligibilityResponse);
/**
 * SOURCE MigrationType @ squareup/rstonboard/service.proto at 801:3
 */
CheckSposToRstMigrationEligibilityResponse.MigrationType = $root.lookupEnum('squareup.rstonboard.CheckSposToRstMigrationEligibilityResponse.MigrationType').values;
/**
 * SOURCE OverallMigrationEligibilityStatus @ squareup/rstonboard/service.proto at 809:3
 */
CheckSposToRstMigrationEligibilityResponse.OverallMigrationEligibilityStatus = $root.lookupEnum('squareup.rstonboard.CheckSposToRstMigrationEligibilityResponse.OverallMigrationEligibilityStatus').values;
/**
 * SOURCE ErrorType @ squareup/rstonboard/service.proto at 823:3
 */
CheckSposToRstMigrationEligibilityResponse.ErrorType = $root.lookupEnum('squareup.rstonboard.CheckSposToRstMigrationEligibilityResponse.ErrorType').values;
/**
 * SOURCE Error @ squareup/rstonboard/service.proto at 836:3
 */
CheckSposToRstMigrationEligibilityResponse.Error = $root.lookupType('squareup.rstonboard.CheckSposToRstMigrationEligibilityResponse.Error');
fixType(CheckSposToRstMigrationEligibilityResponse.Error);
Builder.createAndAttachToType(CheckSposToRstMigrationEligibilityResponse.Error);
/**
 * SOURCE LocationMigrationEligibility @ squareup/rstonboard/service.proto at 841:3
 */
CheckSposToRstMigrationEligibilityResponse.LocationMigrationEligibility = $root.lookupType('squareup.rstonboard.CheckSposToRstMigrationEligibilityResponse.LocationMigrationEligibility');
fixType(CheckSposToRstMigrationEligibilityResponse.LocationMigrationEligibility);
Builder.createAndAttachToType(CheckSposToRstMigrationEligibilityResponse.LocationMigrationEligibility);
/**
 * SOURCE OnboardService @ squareup/rstonboard/service.proto at 891:1
 */
export const OnboardService = $root.lookupService('squareup.rstonboard.OnboardService');
/**
 * SOURCE MenuImportService @ squareup/rstonboard/service.proto at 911:1
 */
export const MenuImportService = $root.lookupService('squareup.rstonboard.MenuImportService');
/**
 * SOURCE MenuService @ squareup/rstonboard/service.proto at 940:1
 */
export const MenuService = $root.lookupService('squareup.rstonboard.MenuService');
/**
 * SOURCE ThirdPartyMenuMigrationService @ squareup/rstonboard/service.proto at 972:1
 */
export const ThirdPartyMenuMigrationService = $root.lookupService('squareup.rstonboard.ThirdPartyMenuMigrationService');